export default defineNuxtPlugin(async nuxtApp => {
  nuxtApp.vueApp.directive('slide', {
    mounted(el, { value, dir }) {
      el.style.overflow = 'hidden'
      dir.slide(el, value)
    },

    updated(el, { value, dir }) {
      dir.slide(el, value)
    },

    slide(el, { active, easing, duration }) {
      el.style.maxHeight = 0
      el.style.transition = `max-height ${duration ? duration : 200}ms`
      el.style.transitionTimingFunction = `${easing ? easing : 'linear'}`
      setTimeout(() => {
        el.style.maxHeight = active ? `${el.scrollHeight}px` : 0
      }, 1)
    },

    getSSRProps() {
      return {}
    }
  })
  
  let observerAnimate = null
  if (process.client) {
    observerAnimate = new IntersectionObserver(entries => {
      for (const { target, isIntersecting } of entries) {
        if (isIntersecting) target.classList.remove('isAnimated')
      }
    })
  }

  nuxtApp.vueApp.directive('animate', {
    mounted(el, { value }) {
      if (process.client) {
        if (value !== false) {
          el.classList.add('isAnimated')
          el.classList.add('animate')
          if (value) el.classList.add(value)
          else el.classList.add('isBottom')

          observerAnimate.observe(el)
        }
      }
    },

    getSSRProps() {
      return {}
    }
  })

  nuxtApp.vueApp.directive('click-outside', {
    beforeMount(el, binding) {
      const handler = e => {
        if (!el.contains(e.target) && el !== e.target) binding.value(e)
      }

      el.__vueClickEventHandler__ = handler
      document.addEventListener('click', handler)
    },

    unmounted(el) {
      document.removeEventListener('click', el.__vueClickEventHandler__)
    },

    getSSRProps() {
      return {}
    }
  })

  nuxtApp.vueApp.directive('parallax', {
    beforeMount(el, binding) {
      const handler = e => {
        let { y, height } = el.getBoundingClientRect()
        const top = y + window.scrollY;
        const docHeight = document.documentElement.clientHeight;

        y = -(y - docHeight)
        const maxHeight = docHeight + height;

        if(y > 0 && y < maxHeight) {
          const percentage = -(top - (window.scrollY + docHeight))/maxHeight
          el.style.transform = `translateY(${percentage*-(binding.value || 200)}rem)`
        }

        if(y < 0) el.style.transform = `translateY(0)`
        if(y >= maxHeight) el.style.transform = `translateY(-${binding.value}rem)`
      }

      el.__nuxtParallax__ = handler
      window.addEventListener('scroll', handler)
    },

    unmounted(el) {
      window.removeEventListener('scroll', el.__nuxtParallax__)
    },

    getSSRProps() {
      return {}
    }
  })
})
